module.exports = __webpack_public_path__ + "static/img/4.a2849ee.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/4/zh/4.png
// module id = DDX5
// module chunks = 0